
const routes = {
    home: {
        id: 'varilux-g9',
        path: '/',
        label: 'varilux_g9_varilux'
    },
}

export default routes;